import { motion } from "framer-motion";
import { Reveal } from "@/lib/motion";
import { PROCESS } from "@/data/site";

export const ProcessSteps = ({ heading = true }) => {
  return (
    <section id="process" className="relative py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        {heading && (
          <div className="max-w-2xl mb-14">
            <Reveal as="p" className="text-xs uppercase tracking-[0.2em] text-primary font-semibold">Our Process</Reveal>
            <Reveal delay={0.05}>
              <h2 className="mt-4 text-4xl md:text-5xl font-heading font-bold tracking-tight">
                A clear path from idea to launch
              </h2>
            </Reveal>
            <Reveal delay={0.1} className="mt-4 text-muted-foreground text-lg">
              Seven simple steps, zero surprises — delivered by a team that treats your business like our own.
            </Reveal>
          </div>
        )}

        <div className="divide-y divide-border border-t border-border">
          {PROCESS.map((step, i) => (
            <motion.div
              key={step.n}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: (i % 3) * 0.05, ease: [0.22, 1, 0.36, 1] }}
              className="group grid md:grid-cols-12 gap-4 md:gap-8 py-8 md:py-10 items-baseline"
              data-testid={`process-step-${step.n}`}
            >
              <div className="md:col-span-3 text-6xl md:text-8xl font-heading font-extrabold tracking-tighter text-stroke group-hover:text-stroke-red transition-all duration-500">
                {step.n}
              </div>
              <h3 className="md:col-span-4 text-2xl md:text-3xl font-heading font-semibold tracking-tight">
                {step.title}
              </h3>
              <p className="md:col-span-5 text-muted-foreground text-lg leading-relaxed">
                {step.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
